import { Component, EventEmitter, Inject, Output } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-modal-file",
  styleUrls: ["./modal-file.scss"],
  templateUrl: "./modal-file.html",
})
export class ModalFileComponent {
  @Output() close = new EventEmitter<void>();

  constructor(@Inject(MAT_DIALOG_DATA) data: any) {
    this.result = data.file;
    this.isPdf = data.isPdf;
  }

  result: Blob;
  fileSrc;
  isPdf: Boolean;

  ngOnInit() {
    this.blobToBase64(this.result, this.isPdf);
  }

  onCloseClick() {
    this.close.emit();
  }

  blobToBase64(blob: Blob, isPdf: Boolean) {
    if (isPdf) {
      this.blobToBase64Pdf(blob);
    } else {
      this.blobToBase64Img(blob);
    }
  }

  blobToBase64Pdf(blob: Blob) {
    var reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      this.fileSrc = reader.result;
    };
  }

  blobToBase64Img(blob: Blob) {
    var reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      var base64 = reader.result;
      var base64Splited = base64.toString().split("base64");
      this.fileSrc = "data:image/jpeg;base64" + base64Splited[1];
    };
  }
}
